/**
 * hfb-reveal.js — the single motion chokepoint for CB Design's bespoke theme.
 *
 * Every element tagged [data-hfb-reveal] fades and rises once as it enters the
 * viewport, via an IntersectionObserver that adds the .hfb-in class. Optional
 * [data-hfb-reveal-stagger] on a container staggers its direct [data-hfb-reveal]
 * children. Motion is expressed entirely in CSS (hfb-brand-tokens); this file
 * only toggles the class, so it costs ~0ms on the critical path.
 *
 * prefers-reduced-motion is honoured in CSS (final state shown immediately);
 * this script also short-circuits so nothing is left hidden if the observer
 * never fires.
 */
(function () {
  'use strict';

  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(nodes) {
    nodes.forEach(function (el) {
      el.classList.add('hfb-in');
    });
  }

  function init() {
    var nodes = Array.prototype.slice.call(
      document.querySelectorAll('[data-hfb-reveal]')
    );
    if (!nodes.length) return;

    // Apply stagger delays for tagged containers.
    document
      .querySelectorAll('[data-hfb-reveal-stagger]')
      .forEach(function (group) {
        var step = parseFloat(group.getAttribute('data-hfb-reveal-stagger')) || 100;
        var children = group.querySelectorAll(':scope > [data-hfb-reveal]');
        children.forEach(function (child, i) {
          child.style.setProperty('--hfb-reveal-delay', i * step + 'ms');
        });
      });

    if (reduce || !('IntersectionObserver' in window)) {
      revealAll(nodes);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('hfb-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    nodes.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan when the theme editor re-renders a section.
  document.addEventListener('shopify:section:load', init);
})();
